export enum ActivityTypeEnum {
  CALLOUT,
  REGULAR,
  AUTOMATED,
  BIDDING,
}

export type ExtractActivityTypeParams = {
  eventName: string;
  userFirstName: string | null;
  userLastName: string | null;
};

export const extractActivityType = ({
  eventName,
  userFirstName,
  userLastName,
}: ExtractActivityTypeParams): ActivityTypeEnum => {
  if (
    eventName &&
    (eventName === 'callout_list_created' || eventName === 'new_callout_list_created')
  ) {
    return ActivityTypeEnum.CALLOUT;
  }
  if (eventName && eventName === 'placed_bid') {
    return ActivityTypeEnum.BIDDING;
  }
  if (userFirstName && userLastName) {
    return ActivityTypeEnum.REGULAR;
  }
  return ActivityTypeEnum.AUTOMATED;
};
